import { WizardStep, WizardStepIndex } from "../../../shared/enums/WizardStep";
import { linkHelper } from "../../../shared/helpers/linkHelper";
import StepActive from "./StepActive";
import StepDone from "./StepDone";
import StepInactive from "./StepInactive";

interface MachineTonnageStepItemProps {
  activeStepIndex: number;
  market: string;
  text: string;
}

const MachineTonnageStepItem = ({
  activeStepIndex,
  market,
  text,
}: MachineTonnageStepItemProps) => {
  const hideMobile =
    activeStepIndex > WizardStepIndex.Product ? "hideStep" : "";
  const stepNumber = WizardStepIndex.MachineTonnage + 1;

  if (activeStepIndex === WizardStepIndex.MachineTonnage) {
    return (
      <StepActive
        hideMobilClass={hideMobile}
        stepNumber={stepNumber}
        text={text}
      />
    );
  }

  if (activeStepIndex < WizardStepIndex.MachineTonnage) {
    return (
      <StepInactive
        hideMobilClass={hideMobile}
        stepNumber={stepNumber}
        text={text}
      />
    );
  }

  const url = linkHelper.link(WizardStep.MachineTonnage, market);
  return <StepDone hideMobilClass={hideMobile} text={text} url={url} />;
};

export default MachineTonnageStepItem;
